module.exports = __webpack_public_path__ + "img/file-lock2-fill.4dc2b7c3.svg";